import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./tile-header-text.html';
import styles from './tile-header-text-hashed.scss';

export default [() => ({
    restrict: 'E',
    replace: true,
    scope: {
        text: '@'
    },
    template: cssUtil.hashTemplate(template, styles)
})];
